import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {catchError, map, Observable, of} from 'rxjs';
import {TenantService} from '../services/tenant.service';

@Injectable({providedIn: 'root'})
export class TenantGuard {

  constructor(private tenant: TenantService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const slug = route.paramMap.get('slug')!;
    return this.tenant.resolve(slug).pipe(
      map(() => true),
      catchError(err => {
        if (err?.status === 404) {
          this.tenant.clear();
        }
        this.router.navigate(['/explore']);
        return of(false);
      })
    );
  }
}
